import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScStepsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  & > .title {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.27;
    text-align: center;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  & > .steps {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  @media (${device.mobile}) {
    & > .title {
      font-size: 20px;
      line-height: 1.3;
    }

    & > .steps {
      display: flex;
      flex-direction: column;
    }
  }
`;
